import { useMutation } from '@tanstack/react-query';

import { SitePricingPlan } from 'src/features/pricing/sites/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/site-pricing-plan/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    parkingId: string;
    site: string;
}

const mutationFn = ({ parkingId, ...data}: DTO): Promise<SitePricingPlan> => {
    return axios.post(formatResourcePath(RESOURCE, {parkingId}), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateSitePricingPlan };
